import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import Layout from '../../component/layout'
import { getItem } from '../../../../utils/localStorage';
import { toastify } from '../../../../utils/toast';
import { makeRequest2 } from '../../../../utils/makeRequest';
import { visitorPreRegistrationURL, getUnitsForFacility, getCustomersURL, getDivisionArray, otpRegistrationURL, otpVerificationURL, resendOtpURL } from '../../../../utils/urls';
import { getLocation } from '../../../../utils/getLocation';


function GateRegistration() {
    const navigate = useNavigate();
    const selectedFacilityId = getItem('selectedFacilityId');
    const facilityId = selectedFacilityId ? selectedFacilityId : null;
    const [units, setUnits] = useState([]);
    const [selectedUnits, setSelectedUnits] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [unitsPerDivision, setUnitsPerDivision] = useState([])
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [carRegistration, setCarRegistration] = useState('');
    const [houseNumber, setHouseNumber] = useState('');
    const [houseId, setHouseId] = useState('');
    const [resident, setResident] = useState('');
    const [carMake, setCarMake] = useState('');
    const [carColor, setCarColor] = useState('');
    const [carOccupants, setCarOccupants] = useState('');
    const [visitorType, setVisitorType] = useState('');
    const [entry, setEntry] = useState('');
    const [divisionArray, setDivisionArray] = useState([]);
    const [division, setDivision] = useState('');
    const [confirmVisit, setConfirmVisit] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeTab, setActiveTab] = useState('gateRegistration');
    const [guardId, setGuardId] = useState('');
    // OTP tab state
    const [otpStep, setOtpStep] = useState('form'); // 'form' | 'verify' | 'verified'
    const [otpFirstName, setOtpFirstName] = useState('');
    const [otpLastName, setOtpLastName] = useState('');
    const [otpIdNumber, setOtpIdNumber] = useState('');
    const [otpPlateNumber, setOtpPlateNumber] = useState('');
    const [otpDivision, setOtpDivision] = useState('');
    const [otpUnitsPerDivision, setOtpUnitsPerDivision] = useState([]);
    const [otpSelectedUnit, setOtpSelectedUnit] = useState(null);
    const [otpPhoneNumber, setOtpPhoneNumber] = useState('');
    const [otpCode, setOtpCode] = useState('');
    const [otpSubmitting, setOtpSubmitting] = useState(false);
    const [otpVisitLogId, setOtpVisitLogId] = useState('');
    const [otpVerifiedPhone, setOtpVerifiedPhone] = useState('');
    const [otpVerifiedName, setOtpVerifiedName] = useState('');
    // Resend OTP state
    const [otpResending, setOtpResending] = useState(false);
    const [otpResendCount, setOtpResendCount] = useState(0);
    const [otpResendsRemaining, setOtpResendsRemaining] = useState(null);
    const [otpResendCooldown, setOtpResendCooldown] = useState(0); // seconds

    const getCurrentUser = async () => {
        try {
            const currentUserValue = await getItem('APPUSER')
            if (currentUserValue) {
                const currentUser = JSON.parse(currentUserValue)
                const guardId = currentUser.user.userId
                setGuardId(guardId)
                console.log("GuardI", guardId)
            }
        }
        catch (err) {
            console.log(err.message)
        }
    }

    const fetchUnitsForFacility = async () => {
        try {
            const value = await getItem('selectedFacilityId')
            const response = await makeRequest2(`${getUnitsForFacility}/${value}`, 'GET', {});

            if (response.success) {
                setUnits(response.data);

            } else {
                throw new Error('Failed to fetch units')
            }
        } catch (error) {
            console.log(error.message)
            toastify(error.message, 'error');
        }
    };

    const fetchDivisionArray = async () => {
        try {
            const value = await getItem('selectedFacilityId')
            const response = await makeRequest2(`${getDivisionArray}/${value}`, 'GET', {});
            if (response.success) {
                setDivisionArray(response.data);
            } else {
                throw new Error('Failed to fetch divisions')
            }
        } catch (error) {
            console.log(error.message)
            toastify(error.message, 'error');
        }
    };

    const fetchCustomersForFacility = async () => {
        try {
            const value = await getItem('selectedFacilityId')
            const response = await makeRequest2(`${getCustomersURL}/${value}`, 'GET', {});

            if (response.success) {
                setCustomers(response.data);
            } else {
                throw new Error('Failed to fetch customers')
            }
        } catch (error) {
            console.log(error.message)
            toastify(error.message, 'error');
        }
    };

    const handleVisitorSubmit = async () => {
        if (isSubmitting) return; // Prevent multiple submissions

        setIsSubmitting(true);
        try {
            const facilityId = await getItem('selectedFacilityId');

            const { latitude: lat, longitude: long } = await getLocation();

            const visitorData = {
                firstName,
                lastName,
                phoneNumber,
                division,
                lat: lat,
                long: long,
                houseId: selectedUnits._id,
                entryPointId: entry._id,
                confirmVisit,
                guardId
            };


            if (!visitorData.firstName) throw new Error('First name is required.');
            if (!visitorData.lastName) throw new Error('Last name is required.');
            if (!visitorData.phoneNumber) throw new Error('Phone number is required.');
            if (!visitorData.division) throw new Error('Entry Road is required.');
            if (!visitorData.houseId) throw new Error('House Number is required.');


            const response = await makeRequest2(visitorPreRegistrationURL + '/' + facilityId, 'POST', visitorData);

            if (response.success) {
                toastify('Visitor added successfully', 'success');
                setFirstName('');
                setLastName('');
                setPhoneNumber('');
                setHouseNumber('');
                setResident('');
                setHouseId('')
                setUnitsPerDivision('');
                setSelectedUnits('');
                setConfirmVisit(!confirmVisit)
                navigate('/facility/visitor_access_management/home');
            }
            else {
                throw new Error(response.error);
            }

        } catch (err) {
            toastify(err.message, 'error')
        } finally {
            setIsSubmitting(false);
        }
    }

    const getCurrentAccessPoint = async () => {
        try {

            const value = await getItem('selectedEntryPoint');
            if (value) {
                const data = JSON.parse(value)
                setEntry(data)
            }

        }
        catch (err) {
            console.log(err.message)
        }
    }

    // ---- OTP tab handlers ----

    const validateOtpFields = () => {
        if (!otpFirstName) throw new Error('First name is required.');
        if (!otpLastName) throw new Error('Last name is required.');
        if (!otpPlateNumber) throw new Error('Plate number is required.');
        if (!otpDivision) throw new Error('Road is required.');
        if (!otpSelectedUnit?._id) throw new Error('House number is required.');
        if (!otpPhoneNumber) throw new Error('Phone number is required.');
    };

    const handleSendOtp = async () => {
        if (otpSubmitting) return;
        setOtpSubmitting(true);
        try {
            validateOtpFields();

            const facilityId = await getItem('selectedFacilityId');

            const payload = {
                phoneNumber: otpPhoneNumber,
                entryPointId: entry?._id,
                guardId,
            };

            const response = await makeRequest2(`${otpRegistrationURL}/${facilityId}`, 'POST', payload);

            if (response.success) {
                const id = response.data?.otpVisitLogId;
                if (!id) throw new Error('Server did not return an OTP log ID');
                setOtpVisitLogId(id);
                setOtpStep('verify');
                // Reset resend bookkeeping for this new OTP session
                setOtpResendCount(0);
                setOtpResendsRemaining(null);
                setOtpResendCooldown(0); // backend doesn't enforce this; frontend does
                toastify('OTP sent successfully', 'success');
            } else {
                throw new Error(response.error || 'Failed to send OTP');
            }
        } catch (err) {
            toastify(err.message, 'error');
        } finally {
            setOtpSubmitting(false);
        }
    };

    const handleVerifyOtp = async () => {
        if (otpSubmitting) return;
        setOtpSubmitting(true);
        try {
            validateOtpFields();
            if (!otpCode) throw new Error('OTP is required.');

            const facilityId = await getItem('selectedFacilityId');

            const payload = {
                otpVisitLogId,
                phoneNumber: otpPhoneNumber,
                otp: otpCode,
                guardId,
                firstName: otpFirstName,
                lastName: otpLastName,
                idNumber: otpIdNumber,
                plateNumber: otpPlateNumber,
                division: otpDivision,
                houseId: otpSelectedUnit._id,
                entryPointId: entry?._id,
            };

            const response = await makeRequest2(`${otpVerificationURL}/${facilityId}`, 'POST', payload);

            if (response.success) {
                setOtpVerifiedPhone(response.phoneNumber || otpPhoneNumber);
                setOtpVerifiedName(`${otpFirstName} ${otpLastName}`.trim());
                setOtpStep('verified');
                toastify('OTP verified — access granted', 'success');
            } else {
                throw new Error(response.error || 'Invalid OTP');
            }
        } catch (err) {
            toastify(err.message, 'error');
        } finally {
            setOtpSubmitting(false);
        }
    };

    const RESEND_COOLDOWN_SECONDS = 30;

    const handleResendOtp = async () => {
        if (otpResending || otpResendCooldown > 0) return;
        setOtpResending(true);
        try {
            const facilityId = await getItem('selectedFacilityId');

            const payload = {
                otpVisitLogId,
                phoneNumber: otpPhoneNumber,
            };

            const response = await makeRequest2(`${resendOtpURL}/${facilityId}`, 'POST', payload);

            if (response.success) {
                // Backend rotates the OTP hash, so clear any entered code
                setOtpCode('');
                setOtpResendCount((c) => c + 1);
                if (typeof response.resendsRemaining === 'number') {
                    setOtpResendsRemaining(response.resendsRemaining);
                }
                // Start cooldown so users can't spam
                setOtpResendCooldown(RESEND_COOLDOWN_SECONDS);
                toastify('A new OTP has been sent to your phone', 'success');
            } else {
                throw new Error(response.error || 'Failed to resend OTP');
            }
        } catch (err) {
            toastify(err.message, 'error');
        } finally {
            setOtpResending(false);
        }
    };

    const resetOtpFlow = () => {
        setOtpStep('form');
        setOtpFirstName('');
        setOtpLastName('');
        setOtpIdNumber('');
        setOtpPlateNumber('');
        setOtpDivision('');
        setOtpUnitsPerDivision([]);
        setOtpSelectedUnit(null);
        setOtpPhoneNumber('');
        setOtpCode('');
        setOtpVisitLogId('');
        setOtpVerifiedPhone('');
        setOtpVerifiedName('');
        setOtpResendCount(0);
        setOtpResendsRemaining(null);
        setOtpResendCooldown(0);
    };

    const handleOtpBack = () => {
        // Unlock fields and return to form state; keep entered details so guard doesn't retype
        setOtpStep('form');
        setOtpCode('');
        setOtpResendCooldown(0);
    };

    const handleClear = () => {
        setFirstName('');
        setLastName('');
        setPhoneNumber('');
        setCarRegistration('');
        setHouseNumber('');
        setCarMake('');
        setCarColor('');
        setCarOccupants('');
        setVisitorType('');
        setResident('');
        setConfirmVisit('');

    }

    useEffect(() => {
        if (otpResendCooldown <= 0) return;
        const id = setTimeout(() => setOtpResendCooldown((s) => s - 1), 1000);
        return () => clearTimeout(id);
    }, [otpResendCooldown]);

    useEffect(() => {
        fetchDivisionArray();
        fetchUnitsForFacility();
        fetchCustomersForFacility();
        getCurrentAccessPoint();
        getCurrentUser();
    }, []);

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Visitor & Access Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Gate Registration</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <div className="card">
                <div className="card-header">
                    <ul className="nav nav-tabs card-header-tabs">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'gateRegistration' ? 'active' : ''}`}
                                onClick={() => setActiveTab('gateRegistration')}
                                type="button"
                            >
                                Gate Registration
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'otp' ? 'active' : ''}`}
                                onClick={() => setActiveTab('otp')}
                                type="button"
                            >
                                OTP
                            </button>
                        </li>
                    </ul>
                </div>

                {activeTab === 'gateRegistration' && (
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-body">
                                <div className="container">

                                    <div className="card">
                                        <div className="card-header">
                                            <h5>Visitor Information</h5>
                                        </div>

                                        <div className="card-body">
                                            <div className='container'>
                                                <div className='row'>
                                                    <div className="col-sm-6">
                                                        <div className="mb-3">
                                                            <label>First Name<span style={{ color: 'red' }}>*</span></label>
                                                            <input className="form-control mt-2" type="text" placeholder="First name"
                                                                value={firstName} onChange={(e) => {
                                                                    let value = e.target.value;
                                                                    setFirstName(value)
                                                                }}
                                                            ></input>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Last Name<span style={{ color: 'red' }}>*</span></label>
                                                            <input className="form-control mt-2" type="text" placeholder="Last name"
                                                                value={lastName} onChange={(e) => {
                                                                    let value = e.target.value;
                                                                    setLastName(value)
                                                                }}
                                                            ></input>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <div className="mb-3">
                                                            <label>Phone Number<span style={{ color: 'red' }}>*</span></label>
                                                            <input className="form-control mt-2" type="text" placeholder="Phone number"
                                                                value={phoneNumber} onChange={(e) => {
                                                                    let value = e.target.value;
                                                                    setPhoneNumber(value)
                                                                }}
                                                            ></input>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <div className="mb-3">
                                                            <label>Road</label>
                                                            <select
                                                                className="form-control mt-2"
                                                                value={division}
                                                                onChange={(e) => {
                                                                    setDivision(e.target.value)
                                                                    if (e.target.value === '') {
                                                                        setUnitsPerDivision([])
                                                                    }
                                                                    else {
                                                                        let filter = units.filter((x) => {
                                                                            return x.division === e.target.value
                                                                        })
                                                                        setUnitsPerDivision(filter)
                                                                    }
                                                                }}
                                                            >
                                                                <option value="">-- Select --</option>
                                                                {divisionArray.map((division) => (
                                                                    <option key={division._id} value={division._id}>
                                                                        {division.divisionName}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <div className="col-sm-6">
                                                        <div className="mb-3">
                                                            <label>Unit</label>
                                                            <Autocomplete
                                                                options={unitsPerDivision}
                                                                getOptionLabel={(option) => option.name || ''}
                                                                value={selectedUnits}
                                                                onChange={(event, newValue) => setSelectedUnits(newValue)}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Select Units"
                                                                        variant="outlined"
                                                                    />
                                                                )}
                                                                renderTags={(value, getTagProps) =>
                                                                    value.map((option, index) => (
                                                                        <Chip
                                                                            key={option._id}
                                                                            label={option.name || ''}
                                                                            {...getTagProps({ index })}
                                                                        />
                                                                    ))
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <input
                                                    type="checkbox"
                                                    checked={confirmVisit}
                                                    value={confirmVisit}
                                                    onChange={(e) => setConfirmVisit(!confirmVisit)}
                                                    style={{ padding: 20 }}
                                                /> &nbsp;
                                                <label className="form-label">Send a Confirmation of Visit to Resident</label>

                                            </div>
                                        </div>

                                    </div>

                                    <div className="text-end mt-2">
                                        <button type="button" className="btn btn-outline-secondary" onClick={handleClear}>Clear</button>
                                        &nbsp;
                                        <button type="button" className="btn btn-primary" onClick={handleVisitorSubmit} disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : 'Submit'}</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'otp' && (
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-body">
                                <div className="container">

                                    <div className="card">
                                        <div className="card-header">
                                            <h5>OTP Verification</h5>
                                        </div>

                                        <div className="card-body">
                                            <div className='container'>

                                                {otpStep === 'verified' ? (
                                                    <div className='row'>
                                                        <div className="col-sm-12">
                                                            <div className="alert alert-success mb-0">
                                                                OTP verified successfully for <strong>{otpVerifiedName}</strong>
                                                                {otpVerifiedPhone && <> (<strong>{otpVerifiedPhone}</strong>)</>}. Access granted.
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className='row'>
                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label>First Name<span style={{ color: 'red' }}>*</span></label>
                                                                    <input className="form-control mt-2" type="text" placeholder="First name"
                                                                        value={otpFirstName}
                                                                        onChange={(e) => setOtpFirstName(e.target.value)}
                                                                        disabled={otpStep === 'verify'}
                                                                    ></input>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Last Name<span style={{ color: 'red' }}>*</span></label>
                                                                    <input className="form-control mt-2" type="text" placeholder="Last name"
                                                                        value={otpLastName}
                                                                        onChange={(e) => setOtpLastName(e.target.value)}
                                                                        disabled={otpStep === 'verify'}
                                                                    ></input>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label>ID Number</label>
                                                                    <input className="form-control mt-2" type="text" placeholder="ID number"
                                                                        value={otpIdNumber}
                                                                        onChange={(e) => setOtpIdNumber(e.target.value)}
                                                                        disabled={otpStep === 'verify'}
                                                                    ></input>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label>Plate Number<span style={{ color: 'red' }}>*</span></label>
                                                                    <input className="form-control mt-2" type="text" placeholder="Plate number"
                                                                        value={otpPlateNumber}
                                                                        onChange={(e) => setOtpPlateNumber(e.target.value)}
                                                                        disabled={otpStep === 'verify'}
                                                                    ></input>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label>Road<span style={{ color: 'red' }}>*</span></label>
                                                                    <select
                                                                        className="form-control mt-2"
                                                                        value={otpDivision}
                                                                        onChange={(e) => {
                                                                            setOtpDivision(e.target.value)
                                                                            if (e.target.value === '') {
                                                                                setOtpUnitsPerDivision([])
                                                                                setOtpSelectedUnit(null)
                                                                            } else {
                                                                                let filter = units.filter((x) => x.division === e.target.value)
                                                                                setOtpUnitsPerDivision(filter)
                                                                                setOtpSelectedUnit(null)
                                                                            }
                                                                        }}
                                                                        disabled={otpStep === 'verify'}
                                                                    >
                                                                        <option value="">-- Select --</option>
                                                                        {divisionArray.map((division) => (
                                                                            <option key={division._id} value={division._id}>
                                                                                {division.divisionName}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label>House Number<span style={{ color: 'red' }}>*</span></label>
                                                                    <Autocomplete
                                                                        options={otpUnitsPerDivision}
                                                                        getOptionLabel={(option) => option.name || ''}
                                                                        value={otpSelectedUnit}
                                                                        onChange={(event, newValue) => setOtpSelectedUnit(newValue)}
                                                                        disabled={otpStep === 'verify'}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label="Select House"
                                                                                variant="outlined"
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="mb-3">
                                                                    <label>Phone Number<span style={{ color: 'red' }}>*</span></label>
                                                                    <input className="form-control mt-2" type="text" placeholder="Phone number"
                                                                        value={otpPhoneNumber}
                                                                        onChange={(e) => setOtpPhoneNumber(e.target.value)}
                                                                        disabled={otpStep === 'verify'}
                                                                    ></input>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {otpStep === 'verify' && (
                                                            <div className='row mt-2'>
                                                                <div className="col-sm-12">
                                                                    <p className="mb-3">
                                                                        An OTP has been sent to <strong>{otpPhoneNumber}</strong>. Enter it below to verify.
                                                                    </p>
                                                                </div>
                                                                <div className="col-sm-6">
                                                                    <div className="mb-3">
                                                                        <label>OTP<span style={{ color: 'red' }}>*</span></label>
                                                                        <input className="form-control mt-2" type="text" placeholder="Enter OTP"
                                                                            value={otpCode} onChange={(e) => setOtpCode(e.target.value)}
                                                                        ></input>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-6 d-flex align-items-end">
                                                                    <div className="mb-3">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-link p-0"
                                                                            onClick={handleResendOtp}
                                                                            disabled={otpResending || otpResendCooldown > 0 || otpResendsRemaining === 0}
                                                                        >
                                                                            {otpResending
                                                                                ? 'Resending…'
                                                                                : otpResendCooldown > 0
                                                                                    ? `Resend OTP in ${otpResendCooldown}s`
                                                                                    : 'Resend OTP'}
                                                                        </button>
                                                                        {otpResendsRemaining !== null && otpResendsRemaining > 0 && (
                                                                            <div className="form-text">
                                                                                {otpResendsRemaining} resend{otpResendsRemaining === 1 ? '' : 's'} remaining
                                                                            </div>
                                                                        )}
                                                                        {otpResendsRemaining === 0 && (
                                                                            <div className="form-text text-danger">
                                                                                No resends remaining. Please start a new request.
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-end mt-2">
                                        {otpStep === 'form' && (
                                            <>
                                                <button type="button" className="btn btn-outline-secondary" onClick={resetOtpFlow} disabled={otpSubmitting}>Clear</button>
                                                &nbsp;
                                                <button type="button" className="btn btn-primary" onClick={handleSendOtp} disabled={otpSubmitting}>
                                                    {otpSubmitting ? 'Sending...' : 'Send OTP'}
                                                </button>
                                            </>
                                        )}

                                        {otpStep === 'verify' && (
                                            <>
                                                <button type="button" className="btn btn-outline-secondary" onClick={handleOtpBack} disabled={otpSubmitting}>
                                                    Back
                                                </button>
                                                &nbsp;
                                                <button type="button" className="btn btn-primary" onClick={handleVerifyOtp} disabled={otpSubmitting}>
                                                    {otpSubmitting ? 'Verifying...' : 'Verify OTP'}
                                                </button>
                                            </>
                                        )}

                                        {otpStep === 'verified' && (
                                            <button type="button" className="btn btn-primary" onClick={resetOtpFlow}>
                                                New Check
                                            </button>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>


        </Layout >
    )
}


export default GateRegistration